import { ApplicationActions, applicationReducer } from "./ApplicationActions";
import { IApplicationContextStore } from "./ApplicationContextStore";

export const reducer = (
    { applicationStore }: IApplicationContextStore,
    action: ApplicationActions
): IApplicationContextStore => ({
    applicationStore: applicationReducer(applicationStore, action as ApplicationActions),
});
